import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import Select from 'react-select';
import { Pagination } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _actions from '../../actions';
import VersionFree from '../../components/structure/VersionFree';
import i18n from '../../i18n';
import AddPlus from '../../components/svg/AddPlus';
import MessagesModal from './MessagesModal';
import constants from '../../constants';
import Trash from '../../components/svg/Trash';
import YesNoDialog from '../../components/common/YesNoDialog';
import DeleteDialog from '../../components/common/DeleteDialog';
import MessagesView from './MessagesView';
import CaptionTooltip from '../../components/common/CaptionTooltip';
import LargeLoading from '../../components/svg/LargeLoading';

class Messages extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            messageOpen: false,
            messageModalContent: {},
            total: 0,
            current: 0,
            limit: 10,
            title: 10,
            showPager: false,
            showNoData: false,
            index: 0,
            history: false,
        };

        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        if (!(this.props.messages.total > 0)) {
            this.props.actions.getMessagesTotal(this.props.profiles.data.organizationId);
        }
        if (this.props.projects.data.length === 0) {
            this.props.actions.getProjects();
        }
        document.body.classList.add('messages-page', 'version-free');
        this.props.actions.getEmbedCode();
        this.props.actions.getForms(100);
        this.props.actions.getMessages(10, 0, this.props.profiles.data.organizationId, moment().utc().format('YYYY-MM-DDTHH:mm:ss'), 0, true);
    }

    componentDidUpdate(prevProps) {
        /* eslint-enable */
        if (this.props.messages.data
            && prevProps.messages.inProgress
            && !this.props.messages.inProgress) {
            if (this.props.messages.data.noOfPages !== null
                && this.props.messages.data.noOfPages !== undefined) {
                if (this.props.messages.data.noOfPages > 1) {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        total: this.props.messages.data.noOfMessages,
                        showPager: true,
                        showNoData: false,
                    });
                } else if (typeof this.props.messages.data === 'string') {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        total: 0,
                        showPager: true,
                        showNoData: true,
                    });
                } else if (this.props.messages.data.noOfMessages == null
                    || this.props.messages.data.noOfMessages === 0) {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        total: this.props.messages.data.noOfMessages,
                        showPager: false,
                        showNoData: true,
                    });
                } else {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        total: this.props.messages.data.noOfMessages,
                        showPager: false,
                        showNoData: false,
                    });
                }
            }
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('messages-page', 'version-free');
    }

    handlePageChanged(event, newPage) {
        if (newPage > 0) {
            this.setState({ current: newPage - 1 });
            let sinceTime = '';
            let beforeTime = '';
            let asc = true;
            if (this.state.index === 0) {
                sinceTime = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
            }
            if (this.state.index !== 0) {
                sinceTime = 0;
                beforeTime = moment().utc().format('YYYY-MM-DDTHH:mm:ss', asc = false);
            }
            this.props.actions.getMessages(
                this.state.limit,
                newPage - 1,
                this.props.profiles.data.organizationId,
                sinceTime,
                beforeTime,
                asc,
            );
        }
    }

    handleLimitChange(evt) {
        // eslint-disable-next-line react/no-access-state-in-setstate,no-mixed-operators
        const newPage = Math.floor(this.state.current * this.state.title / evt.value);
        this.setState({ title: evt.value, current: newPage });
        let sinceTime = '';
        let beforeTime = '';
        let asc = true;
        if (this.state.index === 0) { sinceTime = moment().utc().format('YYYY-MM-DDTHH:mm:ss'); }
        if (this.state.index !== 0) { sinceTime = 0; beforeTime = moment().utc().format('YYYY-MM-DDTHH:mm:ss'); asc = false; }
        this.props.actions.getMessages(
            evt.value,
            newPage,
            this.props.profiles.data.organizationId,
            sinceTime,
            beforeTime,
            asc,
        );
    }

    closeModal = () => {
        this.setState({ messageModalContent: {}, modalOpen: false });
        this.props.actions.clearAlert('message-time');
    }

    saveAction = (message) => {
        const pageInfo = {
            limit: this.state.limit,
            offset: this.state.current,
            orgId: this.props.profiles.data.organizationId,
        };
        if (this.state.history) {
            pageInfo.sinceTime = 0;
            pageInfo.beforeTime = moment().utc().add(1, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
            pageInfo.timeAscending = false;
        } else {
            pageInfo.sinceTime = moment().utc().add(1, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
            pageInfo.timeAscending = true;
        }
        if (message.id) {
            this.props.actions.updateMessage(
                message.id,
                message.subject,
                message.body,
                message.scheduleTime,
                pageInfo,
                message.formMessage,
                message.formId,
                message.formTitle,
            );
        } else {
            this.props.actions.createMessage(
                message.subject,
                message.body,
                message.scheduleTime,
                pageInfo,
                message.formMessage,
                message.formId,
                message.formTitle,
            );
        }
    }

    deleteMessage = () => {
        const pageInfo = {
            limit: this.state.limit,
            offset: this.state.current,
            orgId: this.props.profiles.data.organizationId,
        };
        if (Math.ceil((this.state.total - 1) / this.state.title) - 1 < this.state.current) {
            // eslint-disable-next-line no-plusplus
            pageInfo.offset--;
            if (pageInfo.offset < 0) {
                pageInfo.offset = 0;
            }
            // eslint-disable-next-line react/no-access-state-in-setstate
            this.setState({ current: (pageInfo.offset) });
        }
        if (this.state.history) {
            pageInfo.sinceTime = 0;
            pageInfo.beforeTime = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
            pageInfo.timeAscending = false;
        } else {
            pageInfo.sinceTime = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
            pageInfo.timeAscending = true;
        }
        this.props.actions.deleteMessage(this.state.messageModalContent.id, pageInfo);
        this.closeConfirmDialog();
    }

    openConfirmDialog = (message) => {
        this.setState({ confirmDelete: true, messageModalContent: message });
    }

    closeConfirmDialog = () => {
        this.setState({ confirmDelete: false, messageModalContent: null });
    }

    openMessage = (message) => {
        this.setState({ messageOpen: true, messageModalContent: message });
    }

    closeMessage = () => {
        this.setState({ messageOpen: false, messageModalContent: null });
    }

    handleTabChange = (event, index) => {
        this.setState({ index });
        if (index === 0) {
            this.handleScheduled();
        }
        if (index === 1) {
            this.handleHistory();
        }
    }

    handleHistory = () => {
        this.setState({ history: true, current: 0 });
        const beforeTime = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
        this.props.actions.getMessages(
            this.state.limit,
            0,
            this.props.profiles.data.organizationId,
            0, beforeTime,
            false,
        );
    }

    handleScheduled = () => {
        if (this.state.history) { this.setState({ history: false, current: 0 }); }
        const sinceTime = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
        this.props.actions.getMessages(
            this.state.limit,
            0,
            this.props.profiles.data.organizationId,
            sinceTime,
            0,
            true,
        );
    }

    editMessage = (message) => {
        this.setState({ messageModalContent: message, modalOpen: true });
    }

    copyMessage = (message) => {
        this.setState({
            messageModalContent: {
                body: message.body,
                subject: message.subject,
                formTitle: message.formTitle,
                formId: message.formId,
                formMessage: message.formMessage,
            },
            modalOpen: true,
        });
    }

    addNew = () => {
        this.setState({ messageModalContent: {}, modalOpen: true });
    }

    render() {
        const formOptions = this.props.forms.filtered.map((form) => {
            return {
                value: form.id,
                label: form.name,
            };
        });
        const pagingOptions = [{ value: 10, label: '10' }, { value: 25, label: '25' }, { value: 50, label: '50' }];
        let deleteConfirmModal = '';
        if (this.state.confirmDelete) {
            deleteConfirmModal = (
                <YesNoDialog
                    Message={<DeleteDialog open={i18n.t('messages.delete1')} name={this.state.messageModalContent.subject ? `${this.state.messageModalContent.subject}` : i18n.t('messages.null')} warning={i18n.t('projects.delete2')} />}
                    ExecuteAction={this.deleteMessage}
                    CloseDialog={this.closeConfirmDialog}
                    Visible={this.state.confirmDelete}
                    YesText={i18n.t('delete')}
                    NoText={i18n.t('cancel')}
                    title="Delete Message?"
                />
            );
        }
        return (
            <VersionFree alerts={this.props.alerts}>
                {this.state.messageModalContent
                && this.state.messageOpen
                && (
                    <MessagesView
                        history={this.state.history}
                        close={this.closeMessage}
                        messages={this.state.messageModalContent}
                        Visible={this.state.messageOpen}
                    />
                )}
                {this.state.messageModalContent && this.state.modalOpen
                && (
                    <MessagesModal
                        flags={this.props.flags}
                        alerts={this.props.alerts}
                        history={this.state.history}
                        forms={formOptions}
                        close={this.closeModal}
                        messages={this.state.messageModalContent}
                        Visible={this.state.modalOpen}
                        saveAction={this.saveAction}
                    />
                )}
                {this.props.projects.inProgress
                && (
                    <div id="loading-page">
                        <div id="loading-container_loader">
                            <LargeLoading />
                        </div>
                    </div>
                )}
                {(this.props.projects.data.filter(
                    (project) => { return project.liveVersion; },
                ).length > 0)
                && (
                    <div data-qa="messages-page" id="messages-page" className="form-wrapper">
                        <h1 data-qa="messages-page-header" id="messages-page-header" className="status">{i18n.t('messages.messages')}</h1>
                        <div data-qa="messages-page-table" id="messages-table">
                            <div data-qa="messages-page-table-header" className="messages-table__header" style={{ msGridColumns: '( 1fr )[6]' }}>
                                <Tabs className="messages-tabs" textColor="primary" value={this.state.index} onChange={this.handleTabChange}>
                                    <Tab className="messages-tab" disableFocusRipple disableRipple label={i18n.t('messages.scheduled')} value={0} />
                                    <Tab className="messages-tab" disableFocusRipple disableRipple label={i18n.t('messages.history')} value={1} />
                                </Tabs>
                                <div className="add-button">
                                    {/* eslint-disable-next-line react/button-has-type */}
                                    <button data-qa="messages-page-add-new" className="btn-secondary" onClick={this.addNew}>
                                        <AddPlus size={10} color="#ffffff" />
                                        {' '}
                                        {i18n.t('messages.new')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        { this.props.messages.data
                    && (
                        <div className="messages-table__wrap">
                            <div className="messages-table__body">
                                <div className="messages-table__body-labels" style={{ msGridColumns: '( 1fr )[6]' }}>
                                    <div className="messages-table-title">{i18n.t('messages.title')}</div>
                                    <div className="messages-table-date">{i18n.t('messages.date')}</div>
                                    <div className={`messages-table-time ${this.props.flags.results && this.props.flags.results?.eventMessaging ? '' : 'double'}`}>{i18n.t('messages.time')}</div>
                                    {this.props.flags.results && this.props.flags.results?.eventMessaging && <div className="messages-table-recipients">{i18n.t('messages.recipients')}</div>}
                                    <div className="messages-table-actions">{i18n.t('messages.action')}</div>
                                </div>
                                <div className="messages-table__content">
                                    {(this.props.messages.data.messages
                                        && this.props.messages.data.messages.length > 0)
                                    && this.props.messages.data.messages.map((item) => {
                                        return (
                                            <div data-qa={`messages-table-content-row-${item.id}`} className="messages-table__content-row" key={item.id} style={{ msGridColumns: '( 1fr )[6]' }}>
                                                {/* eslint-disable-next-line */}
                                                <div data-qa={`messages-table-content-title-${item.id}`} className="messages-table-title" onClick={() => { this.openMessage(item); }}>{item.subject}</div>
                                                {/* eslint-disable-next-line */}
                                                <div data-qa={`messages-table-content-date-${item.id}`} className="messages-table-date" onClick={() => { this.openMessage(item); }}>
                                                    {moment(`${item.scheduledTime}Z`).utc().tz(moment.tz.guess())
                                                        .format('MMM DD YYYY')}
                                                </div>
                                                {/* eslint-disable-next-line */}
                                                <div data-qa={`messages-table-content-time-${item.id}`} className={`messages-table-time ${this.props.flags.results && this.props.flags.results?.eventMessaging ? '' : 'double'}`} onClick={() => { this.openMessage(item); }}>
                                                    {moment(`${item.scheduledTime}Z`).utc().tz(moment.tz.guess())
                                                        .format('hh:mm a z')}
                                                </div>
                                                {this.props.flags.results && this.props.flags.results?.eventMessaging && <div data-qa={`messages-table-content-recipients-${item.id}`} className="messages-table-recipients">{item.formTitle ? item.formTitle : i18n.t('messages.everyone')}</div>}
                                                <div data-qa={`messages-table-content-actions-${item.id}`} className="messages-table-actions">
                                                    <CaptionTooltip tooltipText="Copy">
                                                        {/* eslint-disable-next-line */}
                                                        <button
                                                            aria-label="Copy"
                                                            data-qa={`messages-table-content-copy-${item.id}`}
                                                            className="copy"
                                                            style={{ paddingBottom: '3px' }}
                                                            onClick={() => {
                                                                this.copyMessage(item);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon color="#616B7D" icon={['fas', 'clone']} />
                                                        </button>
                                                    </CaptionTooltip>
                                                    <CaptionTooltip tooltipText="Edit">
                                                        {/* eslint-disable-next-line */}
                                                        <button
                                                            aria-label="Edit"
                                                            data-qa={`messages-table-content-edit-${item.id}`}
                                                            className="edit"
                                                            onClick={() => {
                                                                this.editMessage(item);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={['fas', 'pencil']} color="#616B7D" />
                                                        </button>
                                                    </CaptionTooltip>
                                                    <CaptionTooltip tooltipText="Delete">
                                                        {/* eslint-disable-next-line */}
                                                        <button
                                                            aria-label="Delete"
                                                            data-qa={`messages-table-content-delete-${item.id}`}
                                                            className="delete"
                                                            onClick={() => {
                                                                this.openConfirmDialog(item);
                                                            }}
                                                        >
                                                            <Trash />
                                                        </button>
                                                    </CaptionTooltip>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {this.state.showNoData
                                && <div data-qa="messages-table-content-no-messages" className="no-table"> There are no messages to display.</div>}
                                </div>
                            </div>
                            {this.state.showPager
                                ? (
                                    <Pagination className="mbds-pager" onChange={this.handlePageChanged} count={parseInt(Math.ceil(this.state.total / this.state.title), 10)} defaultPage={parseInt(this.state.current + 1, 10)} siblingCount={1} boundaryCount={1} shape="rounded" />
                                )
                                : null}
                            { this.props.messages.data.noOfMessages > 10
                                ? (
                                    <div data-qa="messages-table-no-of-message-dropdown" id="number-changer">
                                        <div className="prefix">Show</div>
                                        <Select
                                            id="number-per-page"
                                            options={pagingOptions}
                                            className="form-selector"
                                            classNamePrefix="form-selector"
                                            value={pagingOptions.length > 0 ? pagingOptions.find((f) => { return f.value === this.state.title; }) : ''}
                                            onChange={this.handleLimitChange}
                                            clearable={false}
                                            disabled={this.props.messages.data.noOfMessages < 10}
                                            isSearchable={false}
                                            menuPlacement="top"
                                        />
                                    </div>
                                )
                                : (
                                    <div id="number-changer" />
                                )}
                            <div id="page-count" data-qa="messages-table-items-per-page" className={`${this.state.showNoData ? 'hidden' : null}`}>
                                <span>Showing </span>
                                {this.state.current + 1 === 1
                                    ? 1
                                    : ((this.state.current) * this.state.title) + 1 }
                                -
                                {(this.state.total
                                    < (this.state.current + 1) * this.state.title)
                                    ? this.state.total
                                    : (this.state.current + 1) * this.state.title }
                                <span> of </span>
                                {this.state.total}
                            </div>
                        </div>
                    )}
                    </div>
                )}
                {!this.props.projects.inProgress && this.props.projects.data.filter(
                    (project) => { return project.liveVersion; },
                ).length === 0 && (
                    <div data-qa="messages-page-empty" id="messages-page-unpublished" className="form-wrapper">
                        <h1 data-qa="messages-page-unpublished-header" id="messages-page-header" className="status">{i18n.t('messages.messages')}</h1>
                        <p data-qa="messages-page-unpublished-subhead" id="messages-page-subhead" className="status subtitle text-center">{i18n.t('messages.subheader-unpublished')}</p>
                    </div>
                )}
                <div className="delete-modal">
                    {deleteConfirmModal}
                </div>
            </VersionFree>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Messages);
